import moment from "moment";
// -
import IconBool from "components/IconBool";
import ConditionalRender from "components/ConditionalRender";

const SenderInfo = ({to, name, _TC, item, attr}) => {

    const TitleComponent = () => {
        if (to && name) {
            return <div><strong>{to}:</strong> <span>{name}</span></div>;
        } else if (to) {
            return <div><strong>{to}</strong></div>
        }
        return <div><span>{name}</span></div>
    }

    return (
        <ConditionalRender condition={item.params_carry[attr]}>
            <div className="card d-inline-block py-2 px-3 m-2">
                <TitleComponent/>
                <div className="small">
                    <ConditionalRender condition={item.queue_at}>
                        <span>{moment(item.queue_at).format("DD-MM-YYYY hh:mm")}</span>
                    </ConditionalRender>
                </div>
                <div>
                <span title={_TC("confirm.sent")} className="me-2">
                    {_TC("confirm.sent.short") + " "} <IconBool value={item.params_send[attr]}/>
                </span>
                    <span title={_TC("confirm.confirmed")}>
                    {_TC("confirm.confirmed.short") + " "} <IconBool value={item.params_ack[attr]}/>
                </span>
                </div>
                <ConditionalRender condition={item.params_cc_at[attr]}>
                    {moment(item.params_cc_at[attr] * 1000).format("DD-MM-YYYY hh:mm")}
                </ConditionalRender>
            </div>
        </ConditionalRender>
    )
}
export default SenderInfo